import styled from 'styled-components';

type Props = {
  hasTemporaryPosition: boolean;
  isAddingVenues: boolean;
};

const SCREEN_MARKER_BORDER_COLOR = 'var(--color-extras-purple-400, #A265FF)';
const SCREEN_MARKER_COLOR = 'rgba(245, 238, 255, 0.80)';

export const MapViewStyled = styled.div<Props>`
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;

  .mapboxgl-ctrl-logo {
    display: none !important;
  }

  .multiFlightViewMap {
    &__venueButton {
      position: absolute;
      bottom: 10px;
      left: 100px;
    }

    &__polygonButton {
      position: absolute;
      bottom: 10px;
      left: 150px;
    }

    &__toolbarContainer {
      display: flex;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      justify-content: center;
      align-items: center;
      padding: 10px 0;
    }

    &__actionToolsPanelContainer {
      display: flex;
      flex-direction: column;
      position: absolute;
      bottom: 12px;
      left: 12px;
      z-index: 1;

      @media (max-width: 1079px) {
        right: var(--spacing-12);
      }
    }

    &__legendContainer {
      display: flex;
      position: absolute;
      top: 12px;
      left: 12px;
      z-index: 1;

      @media (max-width: 1079px) {
        max-width: calc(100% - 2 * var(--spacing-12));
        overflow: auto;
      }
    }

    &__cursorMarker {
      font-size: ${props => props.theme.fontSizeL};
      pointer-events: none;
      --fa-primary-color: ${props => props.theme.uiColors.unconfirmedVenueMarkerColor};
      --fa-secondary-color: ${props => props.theme.uiColors.unconfirmedVenueMarkerFillColor};
      --fa-secondary-opacity: 0.5;

      &--temporary {
        pointer-events: default;
      }
    }

    &__temporaryScreenContainer {
      background-color: ${SCREEN_MARKER_COLOR};
      border-radius: 50%;
      border: 2px solid ${SCREEN_MARKER_BORDER_COLOR};
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      transform: translate(-50%, -50%);
      cursor: pointer;

      &--unconfirmed {
        background-color: ${props => props.theme.uiColors.unconfirmedScreenMarkerColor};
        border: 2px solid ${props => props.theme.uiColors.unconfirmedScreenMarkerBorderColor};
      }
    }

    &__fileLoaderContainer {
      display: flex;
      position: absolute;
      bottom: 0;
      right: 0;
      width: auto;
      justify-content: flex-end;
      padding: var(--spacing-10) var(--spacing-10) var(--spacing-20) var(--spacing-20);

      @media (max-width: 1079px) {
        bottom: var(--spacing-56);
      }

      &--aboveTools {
        align-self: flex-start;
        bottom: auto;
        padding: 0 0 var(--spacing-8);
        position: static;
        right: auto;
      }
    }

    &__temporaryScreen {
      font-size: ${props => props.theme.fontSizeL};
      color: ${props => props.theme.uiColors.unconfirmedScreenMarkerBorderColor};
    }
  }

  .mapboxgl-canvas-container.mapboxgl-interactive, .mapboxgl-ctrl-group button.mapboxgl-ctrl-compass {
    cursor: ${props => {
      if (props.hasTemporaryPosition) {
        return 'default';
      }
      if (props.isAddingVenues) {
        return 'none';
      }
      return 'grab';
    }}
  }
`;
